import React, { useEffect, useRef, useState } from 'react'
import '../styles/contact.css'
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { FaDiscord } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { MdOutlineMail } from "react-icons/md";
import { HiOutlinePhone } from "react-icons/hi2";
import { LiaTelegram } from "react-icons/lia";
import axios from 'axios'
import { IoCheckmarkDoneCircle } from "react-icons/io5";
import { toast } from 'sonner';
import { BiSolidErrorCircle } from 'react-icons/bi';
import { motion } from "motion/react"
import SplitText from '../components/extra/TextPressure';
import Foot from '../components/Foot';
import failure from '../audio/fail.mp3'
import successful from '../audio/success.mp3'

function Contact() {
    const fail = new Audio(failure);
    const success = new Audio(successful);
const successPlay=()=>{
    success.play().catch(function (error) {
    console.log("Sound error")});
}
const failurePlay=()=>{
    fail.play().catch(function (error) {
    console.log("Sound error")});
}
    const [data, setData] = useState({ username: "", email: "", message: "" });
    const [loading, setLoading] = useState(false)
    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
       const handleAnimationComplete = () => {
  console.log('All letters have animated!');
};
    const submitMessage = async (e) => {

        e.preventDefault()
        console.log('contact data', data)
        if (data.username.length < 3) {
            failurePlay()
            toast('Please, Fill in a Proper Name', { icon: <BiSolidErrorCircle className='error_icon' style={{ width: '45px', height: "45px", fontWeight: '650', color: '#b01010', paddingRight: '20px' }} /> })
        } else if (data.email.length < 6) {
             failurePlay()
            toast('Please, Fill in a Proper Email Address', { icon: <BiSolidErrorCircle className='error_icon' style={{ width: '45px', height: "45px", fontWeight: '650', color: '#b01010', paddingRight: '20px' }} /> })
        } else if (data.message.length < 2) {
             failurePlay()
            toast('Please, Fill in  Your Message to Me', { icon: <BiSolidErrorCircle className='error_icon' style={{ width: '45px', height: "45px", fontWeight: '650', color: '#b01010', paddingRight: '20px' }} /> })
        } else if (!validateEmail(data.email)) {
             failurePlay()
            toast('Please, Fill in a Proper Email Address', { icon: <BiSolidErrorCircle className='error_icon' style={{ width: '45px', height: "45px", fontWeight: '650', color: '#b01010', paddingRight: '20px' }} /> })
        } else if (data.username && data.email && data.message && validateEmail(data.email) && !loading) {
            setLoading(true)
             
            await axios.post('https://clusterx.onrender.com/portfolio', data).then(res => {
                setLoading(false)
                console.log('res', res.data.msg)
                 successPlay()
                toast(res.data.msg, { icon: <IoCheckmarkDoneCircle className='success_icon' style={{ width: '45px', height: "45px", fontWeight: '650', color: "#17b621", paddingRight: '20px' }} /> }
                )
                setData({ username: "", email: "", message: "" })
            }).catch(err => {
                 failurePlay()
                setLoading(false)
                console.log('err', err)
                toast('An Error Occurred, Please Check Your Network and Try Again or Use The Icons Bellow The Send Button. Thank You!', { icon: <BiSolidErrorCircle className='error_icon' style={{ width: '45px', height: "45px", fontWeight: '650', color: '#b01010', paddingRight: '20px' }} /> })
            })
        } else {
 failurePlay()
            toast('Please, Fill in the Required Details Properly', { icon: <BiSolidErrorCircle className='error_icon' style={{ width: '45px', height: "45px", fontWeight: '650', color: '#b01010', paddingRight: '20px' }} /> })

        }
    }


  

    return (
              <motion.div className='contact' initial={{ x: 300, opacity: 0 }} whileInView={{ x: 0, opacity: 1 }} transition={{ duration: 0.3, delay: 0 }} viewport={{ amount: 0, once: true }} >
            <motion.div initial={{ y: 200, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} transition={{ duration: 0.2, delay: 0.3 }} 
            viewport={{ amount: 0., once: true }}
             className="contact_body">
      
                <h1 className="contact_top">CONTACT</h1>
            
                <div className="contact_mid">
                    <form onSubmit={submitMessage} action="">
                        <div className="form_sec"><label htmlFor="username">Your Name</label><input id='username' value={data.username} onChange={(e) => setData({ ...data, username: e.target.value })} type="text" /></div>
                        <div className="form_sec"><label htmlFor="email">Your Email</label><input id='email' value={data.email} type="email" onChange={(e) => setData({ ...data, email: e.target.value })} /></div>
                        <div className="form_sec"><label htmlFor="message">Your Message</label><textarea rows="3" name="message" value={data.message} onChange={(e) => setData({ ...data, message: e.target.value })} id="message"></textarea></div>
                        <button className="fx-4 cc-2-1" type='submit'>{loading ? 'Loading...' : 'Send'}</button>
                    </form>
                </div>
                <div className="contact_bottom">
                    <a href="mailto:snotatonline@gmail.com?subject=From portfolio" target="_blank" rel="noopener noreferrer"><MdOutlineMail className='nav_icon' /></a>
                    <a href="tel:+2349129285031" target="_blank"
                        rel="noopener noreferrer"><HiOutlinePhone className='nav_icon' /></a>
                    <a href="https://wa.me/message/LFDTK3X5DS2GA1" target="_blank"
                        rel="noopener noreferrer"><FaWhatsapp className='nav_icon' /></a>
                    <a href="https://t.me/Olawale_dev" target="_blank" rel="noopener noreferrer"><LiaTelegram className='nav_icon' /></a>
                </div>
            </motion.div> <div className="contact_foot"><Foot /></div> </motion.div>
    )
}

export default Contact
